const zh = {
  ACTIVITY: '活动',
  ADD_INTERVAL: '添加时段',

  CREATE_ACTIVITY: '新建活动',
  CREATE_FILTER_CONFIGURATION: '保存筛选',
  CONFIRM_FILTER_DELETE: '确定要删除此筛选配置吗？',
  RECORDS: '记录',
  RESTORE: '恢复',
  CHANGE_PASSWORD: '修改密码',
  RUNNING: '进行中',
  SAVE: '保存',
  SEARCH: '搜索',
  SAVE_FILTER_CONFIGURATION: '保存筛选',
  SELECT_TIMEZONE: '选择时区',
  SELECT_TYPES: '选择类型',
  SELECT_ACTIVITY: '选择活动',
  SELECT_TAGS: '选择标签',
  SELECT_FILTER: '选择筛选',
  SETTINGS: '设置',
  START_ACTIVITY: '开始',
  LOG_ACTIVITY: '记录',
  STATUS: '状态',
  STOPPED: '已停止',
  STOP: '停止当前活动',
  START: '开始',
  TIME: '时间',
  SIGN_IN: '登录',
  SUMMARY: '汇总',
  TIMEZONE: '时区',
  TOTAL: '总计',
  GROUPED: '趋势',
  EDIT: '编辑',
  EDIT_USER: '编辑用户',
  EDIT_ACTIVITY: '编辑活动',
  ENTER_USERNAME: '请输入用户名',
  ENTER_PASSWORD: '请输入密码',
  FILTER_NAME_PLACEHOLDER: '输入筛选名称',
  PASSWORD: '密码',
  REPEAT_PASSWORD: '确认密码',
  PAUSED: '已暂停',
  PAUSE: '暂停当前活动',
  FINISH: '结束',
  FORGOT_PASSWORD: '忘记密码',
  HISTORY: '历史',
  INTERVALS: '时段',
  COMMENT: '备注',
  DURATION: '时长',
  DOWNLOAD_HISTORY: '导出',
  EXPORT: '导出',
  EXPORT_PDF: 'PDF报告',
  EXPORT_PDF_ERROR_TITLE: '导出错误',
  EXPORT_PDF_LIMIT_EXCEEDED: 'PDF导出限制为{limit}天。所选范围包含{days}天。请选择较小的日期范围。',
  EXPORT_PDF_NO_DATA: '所选日期范围内没有可导出的数据。',
  EXPORT_EXCEL: 'Excel报告',
  EXPORT_EXCEL_ERROR_TITLE: '导出错误',
  EXPORT_EXCEL_LIMIT_EXCEEDED: 'Excel导出限制为{limit}天。所选范围包含{days}天。请选择较小的日期范围。',
  EXPORT_EXCEL_NO_DATA: '所选日期范围内没有可导出的数据。',
  TAGS: '标签',
  TODAY: '今天',
  THIS_WEEK: '本周',
  THIS_MONTH: '本月',
  TYPE_ID: '活动类型',
  TYPES: '类型',
  YES: '是',
  YESTERDAY: '昨天',
  NO: '否',
  NO_RESULTS: '未找到结果',
  NO_DATA_FOR_RANGE: '所选日期范围内没有记录',
  NO_DATA_FOR_RANGE_AND_FILTERS: '所选日期范围和筛选条件下没有记录',
  NONE: '不做任何操作（允许多个活动同时运行）',
  DELETE: '删除',
  DELETE_ACTIVITY_CONFIRM: '确定要删除此活动吗？所有时段都将被删除。',
  DELETE_INTERVAL: '删除时段',
  DELETE_INTERVAL_CONFIRM: '确定要删除此时段吗？',
  INSERT_BETWEEN: '插入中间',
  INSERT_NEW: '插入新建',
  USER: '用户',
  FIRST_NAME: '名',
  LAST_NAME: '姓',
  LAST_WEEK: '上周',
  LAST_MONTH: '上月',
  LOAD_MORE: '加载更多',
  USER_NAME: '邮箱',
  FULL_PATH: '显示活动类型完整路径',
  LANGUAGE: '语言',
  SELECT_LANGUAGE: '选择语言',
  ON_START_ACTION: '开始时的操作',
  DARK_MODE: '深色模式',
  GOALS: '目标',
  ADD_RECORD: '添加记录',
  CALENDAR: '日历',
  CALENDAR_LIMIT_WARNING: '日历视图限制为{days}天。所选范围包含{selected}天。显示 {showingFrom} - {showingTo}。',
  COPY: '复制',
  PASTE: '粘贴',
  ACTIVITY_COPIED: '"{name}"已复制。点击空白区域粘贴。',
  CANCEL: '取消',

  // What's New
  WHATS_NEW_TITLE: '新功能',
  WHATS_NEW_GOT_IT: '知道了！',
  WHATS_NEW_CALENDAR_TITLE: '日历视图',
  WHATS_NEW_CALENDAR_DESC: '用精美的日历布局可视化您的时间：',
  WHATS_NEW_CALENDAR_FEATURE_1: '支持缩放的交互式周视图',
  WHATS_NEW_CALENDAR_FEATURE_2: '点击空白时段快速添加活动',
  WHATS_NEW_CALENDAR_FEATURE_3: '拖拽事件边缘调整时间',
  WHATS_NEW_CALENDAR_FEATURE_4: '在不同日期间复制粘贴活动',
  WHATS_NEW_CALENDAR_FEATURE_5: '智能识别事件间隙便于插入',
  WHATS_NEW_BLOCKS_TITLE: '方块视图',
  WHATS_NEW_BLOCKS_DESC: '紧凑的网格视图，以15分钟为单位显示您的一天。悬停查看详情，点击编辑。',
  WHATS_NEW_PDF_TITLE: 'PDF导出',
  WHATS_NEW_PDF_DESC: '生成包含图表和活动明细的详细PDF报告，支持任意日期范围。',
  WHATS_NEW_UI_TITLE: '界面焕新',
  WHATS_NEW_UI_DESC: '更简洁现代的设计，改进了导航和视觉一致性。',
  WHATS_NEW_DARKMODE_TITLE: '快捷深色模式切换',
  WHATS_NEW_DARKMODE_DESC: '深色模式现在可以直接从侧边栏切换，随时轻松使用。',
  WHATS_NEW_FEEDBACK: '发现问题或想要反馈这些更新？请联系我们：',
}

export default zh
